<script setup>
import { ref, computed } from 'vue'
const props = defineProps({
	to: {
		type: Object,
	},
	direction: {
		type: String,
		default: 'left',
	},
	size: {
		type: String,
	},
})

const arrows = ref({
	left: 'https://cdn.papercrowns.com/website/images/elements/etches/arrow-left.svg',
	right: 'https://cdn.papercrowns.com/website/images/elements/etches/arrow-right.svg',
	up: 'https://cdn.papercrowns.com/website/images/elements/etches/arrow-up.svg',
	down: 'https://cdn.papercrowns.com/website/images/elements/etches/arrow-down.svg',
})
const adjustments = ref({
	left: '-translate-x-0.5 group-hover:-translate-x-1',
	right: 'translate-x-0.5 group-hover:translate-x-1',
	up: '-translate-y-0.5 group-hover:-translate-y-1',
	down: 'translate-y-0.5 group-hover:translate-y-1',
})

const arrow = computed(() => arrows.value[props.direction])
const adjustment = computed(() => adjustments.value[props.direction])
</script>

<template>
	<router-link :class="['group relative flex size-20 items-center justify-center overflow-hidden lg:size-24', { 'lg:size-20': size == 'sm' }]" :to="to" v-if="to">
		<img :class="['z-10 size-6 transition-all duration-300 ease-in-out lg:size-7', adjustment, { 'lg:size-[1.5rem]': size == 'sm' }]" :src="arrow" alt="Arrow" />
		<img class="absolute object-contain grayscale transition-all duration-200 hover:grayscale-0" src="https://cdn.papercrowns.com/website/images/elements/frame/square-left-gold.png" alt="Square Frame" />
	</router-link>
	<button class="group flex h-20 w-20 items-center justify-center overflow-hidden lg:h-24 lg:w-24" v-else>
		<img :class="['z-10 h-6 w-6 transition-all duration-300 ease-in-out lg:h-7 lg:w-7', adjustment]" :src="arrow" alt="Arrow" />
		<img class="absolute object-contain grayscale transition-all duration-200 hover:grayscale-0" src="https://cdn.papercrowns.com/website/images/elements/frame/square-left-gold.png" alt="Square Frame" />
	</button>
</template>
